(() => {
  function init(scope = document) {
    const panel = document.querySelector('[data-seasonal-dialog]');
    if (!panel || panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    let opener = null;
    const markSeen = () => { try { sessionStorage.setItem('soily-soil-notes-seen-v2', '1'); } catch (_) {} };
    const show = (trigger) => {
      if (panel.open || document.querySelector('dialog[open]')) return;
      opener = trigger || document.activeElement;
      panel.showModal();
      document.body.classList.add('modal-open');
      panel.querySelector('[data-seasonal-close]').focus();
      markSeen();
    };
    const close = () => panel.close();
    panel.querySelectorAll('[data-seasonal-close]').forEach(button => button.addEventListener('click', close));
    panel.addEventListener('cancel', event => { event.preventDefault(); close(); });
    panel.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
      if (opener && opener !== document.body && opener.isConnected) opener.focus({preventScroll: true});
    });
    panel.addEventListener('click', event => {
      if (event.target !== panel) return;
      const box = panel.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    });
    document.querySelectorAll('[data-seasonal-open]').forEach(button => button.addEventListener('click', () => show(button)));
    let seen = false;
    try { seen = sessionStorage.getItem('soily-soil-notes-seen-v2') === '1'; } catch (_) {}
    const result = panel.querySelector('[data-signup-success], [data-signup-error]');
    if (result) { show(); result.focus(); }
    const purchasePage = document.body.dataset.productPage === 'true' || Boolean(document.querySelector('.cart-page'));
    if (panel.dataset.arrival === 'true' && !seen && !purchasePage) window.setTimeout(() => {
      if (!panel.isConnected || document.visibilityState === 'hidden') return;
      const active = document.activeElement;
      if (active && active !== document.body && active.matches('input, select, textarea, button, a')) return;
      show();
    }, 12000);
  }
  document.addEventListener('shopify:section:unload', event => {
    const dialog = event.target.querySelector('[data-seasonal-dialog]');
    if (dialog?.open) dialog.close();
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
  });
  init();
  document.addEventListener('shopify:section:load', () => init());
})();
